"use client";

import { useGetQuoteStore } from "@/store/useGetQuoteStore";
import { memo, useCallback, useEffect } from "react";
import { useRouter } from "next/navigation";
import OrderCard, {
  OrderCardHeader,
} from "@/components/screen/global-components/order/OrderCard";
import { cn } from "@/lib/utils";
import ConfirmedOrderCardContent from "./components/ConfirmedOrderCardContent";

export const ConfirmedOrderCard = ({
  className,
}: React.ComponentProps<"div">) => {
  const router = useRouter();
  const { cleanUp } = useGetQuoteStore();

  useEffect(() => {
    cleanUp();
  }, []);

  const handleCompleteOrder = useCallback(() => {
    requestAnimationFrame(() => {
      router.push("/");
    });
  }, [router]);

  return (
    <OrderCard
      topSlot={
        <OrderCardHeader
          title="Quote Request Received."
          variant="success"
          className="max-md:hidden"
        />
      }
      onCompleteOrder={handleCompleteOrder}
      buttonLabel="Go to homepage"
      className={cn(
        "max-md:rounded-none max-md:px-0 max-md:border-0 max-md:shadow-none",
        className
      )}
    >
      <ConfirmedOrderCardContent />
    </OrderCard>
  );
};

export default memo(ConfirmedOrderCard);
